import { render, staticRenderFns } from "./FormBuilderV2.vue?vue&type=template&id=9f5028dc&scoped=true"
import script from "./FormBuilderV2.vue?vue&type=script&lang=js"
export * from "./FormBuilderV2.vue?vue&type=script&lang=js"
import style0 from "./FormBuilderV2.vue?vue&type=style&index=0&id=9f5028dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5028dc",
  null
  
)

export default component.exports